define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isUnbadgedUser = void 0;
    const isUnbadgedUser = (user) => {
        var _a, _b;
        const domainMatchType = (_b = (_a = user === null || user === void 0 ? void 0 : user.profile) === null || _a === void 0 ? void 0 : _a.badgingInformation) === null || _b === void 0 ? void 0 : _b.domainMatchType;
        if (!domainMatchType) {
            return false;
        }
        return domainMatchType.startsWith("UNBADGED_") || domainMatchType === "PENDING_ENROLLMENT";
    };
    exports.isUnbadgedUser = isUnbadgedUser;
});
